"use strict";

module.exports = {
  'name': 'transpose',
  'category': 'Matrix',
  'syntax': ['x\'', 'transpose(x)'],
  'description': 'Transpose a matrix',
  'examples': ['a = [1, 2, 3; 4, 5, 6]', 'a\'', 'transpose(a)'],
  'seealso': ['concat', 'det', 'diag', 'identity', 'inv', 'ones', 'range', 'size', 'squeeze', 'subset', 'trace', 'zeros']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/matrix/transpose.js
// module id = 909
// module chunks = 0